import dashBoardRoutes from '@modules/iot/hydrasolo/dashboard/routes';
import { Route } from 'react-router-dom';

const hydrasoloRoutes = <Route path="hydrasolo">{dashBoardRoutes}</Route>;

export default hydrasoloRoutes;
